import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  disableTenantCustomDomain,
  enableTenantCustomDomain,
  fetchTenantCustomDomains,
} from './customDomainsApi';
import type { TenantCustomDomain } from './customDomainsApi.types';
import { buildTenantCustomDomainsQueryKey } from './customDomainsQueryKeys';

export function useTenantCustomDomainsQuery(
  tenantId: string
): UseQueryResult<TenantCustomDomain[], Error> {
  return useQuery({
    queryKey: buildTenantCustomDomainsQueryKey(tenantId),
    queryFn: function loadTenantCustomDomains() {
      return fetchTenantCustomDomains(tenantId);
    },
  });
}

export function useDisableTenantCustomDomainMutation(
  tenantId: string
): UseMutationResult<TenantCustomDomain, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function disableCustomDomain(customDomainId: string) {
      return disableTenantCustomDomain(tenantId, customDomainId);
    },
    onSuccess: function invalidateTenantCustomDomains() {
      queryClient.invalidateQueries({ queryKey: buildTenantCustomDomainsQueryKey(tenantId) });
    },
  });
}

export function useEnableTenantCustomDomainMutation(
  tenantId: string
): UseMutationResult<TenantCustomDomain, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function enableCustomDomain(customDomainId: string) {
      return enableTenantCustomDomain(tenantId, customDomainId);
    },
    onSuccess: function invalidateTenantCustomDomains() {
      queryClient.invalidateQueries({ queryKey: buildTenantCustomDomainsQueryKey(tenantId) });
    },
  });
}
